module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/111-afghanistan-9c3cd26fbef0396a885b5c33747662ff.svg";